export const environment = {
  production: true,
  s3BaseUrl: 'https://ribera.s3.us-east-1.amazonaws.com/lajoya/landing/assets'
};
